import React, { useEffect, useState } from 'react';

import AdminPage from 'components/AdminPage';
import UserToolbar from 'crud/users/UserToolBar';
import UserForm from 'crud/users/UserForm';
import UserCard from 'crud/users/UserCard';
import { object, string, array, boolean } from 'yup';
import useAuth from 'hooks/useAuth';
import useFirestore from 'hooks/useFirestore';
import { UserAwardsContext } from 'crud/users/UserAwardsContext';

export default function Users() {
	const { createUser, deleteUser, updateUser } = useAuth();

	const { getAwards } = useFirestore();

	// Para que cada tarjeta muestre por nombre los premios del jurado.
	const [awards, setAwards] = useState([]);

	useEffect(() => {
		getAwards(setAwards);
	}, [getAwards]);

	const schema = object({
		actived: boolean(),
		roles: array(
			object({
				value: string(),
				label: string(),
				checked: boolean()
			})
		),
		title: string().required('El nombre es obligatorio'),
		email: string().email('Ingrese un mail con el formato correcto').required('El mail es obligatorio')
	});

	const sortOptions = [
		{
			value: 'title',
			label: 'Nombre'
		},
		{
			value: 'email',
			label: 'Mail'
		}
	];

	// `awards` sólo se registra cuando el rol Juez está tildado; sin el default
	// llega undefined a la Cloud Function y Firestore rechaza el documento entero.
	const createItem = (fields) => {
		return createUser(fields.email, fields.title, fields.roles, fields.awards || []);
	};

	const updateItem = (uid, fields) => {
		return updateUser(uid, fields.email, fields.title, fields.roles, fields.awards || []);
	};

	const deleteItem = (uid) => {
		return deleteUser(uid);
	};

	return (
		<UserAwardsContext.Provider value={awards}>
			<AdminPage
				title="Usuarios"
				seoTitle="Administración de usuarios"
				sortOptions={sortOptions}
				collection="users"
				schema={schema}
				externalCreateItem={createItem}
				externalUpdateItem={updateItem}
				externalDeleteItem={deleteItem}
				ItemFormFields={UserForm}
				ItemCard={UserCard}
				ItemToolBar={UserToolbar}
			/>
		</UserAwardsContext.Provider>
	);
}
